import { effect, inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import {
  finalize,
  map,
  ReplaySubject,
  skipWhile,
  take,
  withLatestFrom
} from "rxjs";
import { GlobalState } from "src/app/common/providers/app-state-provider/types/global-state";

export const authGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  const ready = new ReplaySubject<boolean>(1);
  const isReady = store.selectSignal((state: GlobalState) =>
    state.appState.initialized
  );
  const watcher = effect(() =>
    ready.next(
      isReady()
    )
  );

  return ready.pipe(
    skipWhile((userReady) => !userReady),
    take(1),
    withLatestFrom(store.select((s: GlobalState) => s.appState)),
    map(([, appState]) => {
      if (!appState.isAuthenticated) {
        router.navigate(['/login']);
        return false;
      }

      return appState.isAuthenticated;
    }),
    finalize(() => watcher.destroy())
  );
};
